/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Portada_Informacion from "./Componentes/Portada_Informacion";
import Puntos_Informacion from "./Componentes/Puntos_Informacion";
import Documentacion_Informacion from "./Componentes/Documentacion_Informacion";
import Mision_Vision_Informacion from "./Componentes/Mision_Vision_Informacion";
import {useEffect, useState} from "react";
import {irArriba} from "../../Utilidades/irArriba";
import {useParams} from "react-router-dom";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {marcarEvento} from "../../Servicios/Analiticas/marcarEvento";

const Seccion_Proyecto = () => {
    const parms = useParams()
    const [proyecto, setProyecto] = useState({})

    useEffect(() => {
        irArriba()
        marcarEvento('ver_proyectos')
        if (parms && parms.id) {
            obtenerDoc('proyectos', parms.id).then((dox) => {
                if (dox.res) {
                    setProyecto(dox.data)
                }
            })
        }

    }, [parms]);
    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <Portada_Informacion item={proyecto} />
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 8, mb: 8}}>
                <Puntos_Informacion item={proyecto}/>
            </Grid2>

        </Grid2>
    )

}
export default Seccion_Proyecto;